import { createContext, useContext } from 'react';

/* ── Dark Mode Context ──
   H3 Rev 2: DEV-only warning if toggle() called outside Provider — catches
   missing wrap in test/dev environments. Silent no-op in production builds
   (preserves current behavior — page must never crash because of theme). */
const ThemeContext = createContext({
  dark: false,
  toggle: () => {
    if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
      console.warn('[Theme] toggle() called outside ThemeContext.Provider — no-op');
    }
  }
});
export function useTheme() { return useContext(ThemeContext); }
export { ThemeContext };
